export const details = [
  {
    name: "zoom",
    features: [
      "Automatically create Zoom meetings at the time an bookingType is scheduled.",
      "Instantly share unique conferencing details upon confirmation."
    ],
    requirements: [
      "A Zoom account"
    ]
  },
];
